import {inject, Injectable} from "@angular/core";
import {ICountry} from "../interfaces/ICountry";
import {IRegionTaxRate} from "../interfaces/IRegionTaxRate";
import {IUpdateRegionTaxRate} from "../interfaces/IUpdateRegionTaxRate";
import {APIService} from "./api.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GeographyService {

  public apiService: APIService = inject(APIService);

  public allCountriesWithRegions(): Observable<ICountry[]> {
    return this.apiService.MakeGetRequest<ICountry[]>(`countries/with-regions`);
  }

  public getAllowedGameTypesForRegion(regionId: string): Observable<number[]> {
    return this.apiService.MakeGetRequest<number[]>(`regions/${regionId}/allowed-game-types`);
  }

  public getActiveTaxRateForRegion(regionId: string): Observable<IRegionTaxRate> {
    return this.apiService.MakeGetRequest<IRegionTaxRate>(`admin/region-tax-rates/${regionId}/active`);
  }

  public getTaxRatesForRegion(regionId: string): Observable<IRegionTaxRate[]> {
    return this.apiService.MakeGetRequest<IRegionTaxRate[]>(`admin/region-tax-rates/${regionId}`);
  }

  public updateRegionTaxRate(command: IUpdateRegionTaxRate): Observable<any> {
    return this.apiService.MakePutRequest('admin/region-tax-rates', command);
  }

  public cancelScheduledTaxRate(regionId: string, taxRateId: string): Observable<any> {
    return this.apiService.MakeDeleteRequest(`admin/region-tax-rates/${regionId}/scheduled/${taxRateId}`, null);
  }
}
